import { http } from './client';
import type { IntegrationKey, IntegrationStatus, SystemSnapshot } from './types';

export const systemApi = {
  async get(): Promise<SystemSnapshot> {
    const res = await http.get<SystemSnapshot>('/v1/bot/system');
    return res.data;
  },

  async setIntegrationEnabled(
    key: IntegrationKey,
    enabled: boolean,
  ): Promise<IntegrationStatus> {
    const res = await http.patch<{ status: IntegrationStatus }>(
      `/v1/bot/integrations/${encodeURIComponent(key)}/enabled`,
      { enabled },
    );
    return res.data.status;
  },
};
